import * as blUrls from 'lib/urls'

export const socialLinks = [
  { icon: 'fa-instagram', href: blUrls.instagramUrl, name: 'Instagram' },
  {
    icon: 'fa-facebook-official',
    href: blUrls.facebookUrl,
    name: 'Facebook',
  },
  { icon: 'fa-pinterest', href: blUrls.pinterestUrl, name: 'Pinterest' },
  { icon: 'fa-twitter', href: blUrls.twitterUrl, name: 'Twitter' },
  { icon: 'fa-youtube-play', href: blUrls.youtubeUrl, name: 'Youtube' },
]
